import type { GridColDef } from '@mui/x-data-grid';

import HoverCopyCell from '@/components/table-data-grid/HoverCopyCell';
import { dateUtils } from '@/utils/date';

export const columns = (): GridColDef[] => [
    {
        field: 'code',
        headerName: 'Mã khách hàng',
        editable: false,
        sortable: false,
        minWidth: 200,
        flex: 1,
        renderCell: params => <HoverCopyCell value={params.row.code} />,
    },
    {
        field: 'name',
        headerName: 'Tên',
        editable: false,
        sortable: false,
        minWidth: 350,
        flex: 1,
        renderCell: params => <HoverCopyCell value={params.row.name} />,
    },
    {
        field: 'address',
        headerName: 'Địa chỉ',
        editable: false,
        sortable: false,
        minWidth: 400,
        flex: 1,
        renderCell: params => <HoverCopyCell value={params.row.address} />,
    },
    {
        field: 'deviceCount',
        headerName: 'Số lượng thiết bị',
        editable: false,
        sortable: true,
        minWidth: 150,
        flex: 1,
        sortingOrder: ['asc', 'desc'],

        renderCell: params => <HoverCopyCell value={params.row.deviceCount} />,
    },
    {
        field: 'createdDate',
        headerName: 'Ngày tạo',
        editable: false,
        sortable: true,
        minWidth: 150,
        flex: 1,
        sortingOrder: ['asc', 'desc'],
        renderCell: params => (
            <HoverCopyCell value={dateUtils.getDate(params.row.createdDate)} />
        ),
    },
];
